// For action types that don't fit into any particular slice
var GLOBAL = 'global';

// eslint-disable-next-line import/prefer-default-export
export var QC_FINISHED = "".concat(GLOBAL, "/qcFinished");